import React, { useState } from "react";
import { Field, InitialsIcon, Nav, Row, SecondaryRow, TopContainerIcons, Wrapper } from "./styled";
import HelpIcon from "../../../Icons/HelpIcon";
import { HELP } from "./constants";

const LateralMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper
      onClick={() => {
        open();
      }}
    >
      <Nav visible={isOpen}>
        <TopContainerIcons isOpen={isOpen}>
          <Row isOpen={isOpen}>
            <InitialsIcon>DM</InitialsIcon>
            <Field isOpen={isOpen}>Demo</Field>
          </Row>
          <SecondaryRow isOpen={isOpen}>
            <HelpIcon />
            <Field isOpen={isOpen}>{isOpen && HELP}</Field>
          </SecondaryRow>
        </TopContainerIcons>
      </Nav>
    </Wrapper>
  );
};

export default LateralMenu;
